import moment from "moment";
import rangeArray from "./rangeArray";

export function getDiasMes(mes: string) {
  const primeiroDiaMes = 1;

  const ultimoDiaMes = moment(mes, "YYYY-MM").endOf("month").daysInMonth();

  const diasMes = rangeArray(primeiroDiaMes, ultimoDiaMes);

  return diasMes;
}
